import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import IconSvg from 'src/assets/icons/IconSvg';
import { useViewport } from '../../context/ViewportContext';

const NotificationsDropdown = () => {
  const { isMobile } = useViewport();

  return (
    <Menu>
      <MenuButton className="bg-brand-black text-grayscale-400 p-2.5 rounded-lg">
        <IconSvg icon={isMobile ? 'notificationS' : 'notificationM'} />
      </MenuButton>

      <MenuItems
        transition
        anchor="bottom end"
        className="mt-[19px] xl:!mt-1.5 z-50 xl:w-[280px] w-full h-[calc(100vh-148px)] xl:h-auto"
      >
        <MenuItem>
          <div className="bg-[#1B1B1F] bg-opacity-60 backdrop-blur-sm absolute top-0 left-0 w-full h-full z-[-1] xl:hidden"></div>
        </MenuItem>

        <div className="px-5 py-5 space-y-3 rounded-b-lg xl:px-4 xl:py-3 xl:rounded-t-lg bg-grayscale-900">
          <div className="flex justify-between items-center">
            <div className="font-medium text-brand-magnolia">Notifications</div>

            <div className="text-sm underline text-brand-tangerine">Mark All as Read</div>
          </div>

          <div className="px-3 py-2 w-full rounded-lg bg-brand-black">
            <div className="mb-1.5">
              <div className="flex gap-1 items-center mb-1">
                <div className="w-6 h-6 bg-white rounded-full"></div>

                <div className="font-medium text-grayscale-200">Raffle Ended</div>
              </div>

              <p className="text-sm text-grayscale-400">Raffle: Raffle name here has ended</p>
            </div>

            <div className="text-xs text-brand-granite">2m ago</div>
          </div>

          <div className="px-3 py-2 w-full rounded-lg bg-grayscale-800">
            <div className="mb-1.5">
              <div className="flex gap-1 items-center mb-1">
                <div className="w-6 h-6 bg-white rounded-full"></div>

                <div className="font-medium text-grayscale-200">Raffle Ended</div>
              </div>

              <p className="text-sm text-grayscale-400">Raffle: Raffle name here has ended</p>
            </div>

            <div className="text-xs text-brand-granite">2m ago</div>
          </div>

          <div className="px-3 py-2 w-full rounded-lg bg-grayscale-800">
            <div className="mb-1.5">
              <div className="flex gap-1 items-center mb-1">
                <div className="w-6 h-6 bg-white rounded-full"></div>

                <div className="font-medium text-grayscale-200">Raffle Ended</div>
              </div>

              <p className="text-sm text-grayscale-400">Raffle: Raffle name here has ended</p>
            </div>

            <div className="text-xs text-brand-granite">2m ago</div>
          </div>
        </div>
      </MenuItems>
    </Menu>
  );
};

export default NotificationsDropdown;
